import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { Auth } from '../../autentication/Auth';
import { Question } from './../../autentication/models/question';
import { Sms } from './model/sms';

@Injectable()
export class ChangeDigitalSignatureService {

	constructor(private http: HttpClient) { }

	changeDigitalSignature(changeDigitalSignatureData: any): Observable<any> {
		const password = changeDigitalSignatureData.signatures.signature;

		const dataResetDigitalSignatureData = {
			CPF: Auth.getInstance().getUser().cpf,
			Senha: password
		};

		return this.http.put(endpoints.accounts.updateTransactionPassword, dataResetDigitalSignatureData);
	}

	getSecurityQuestions(cpf: string): Observable<Question[]> {
		return this.http.get(endpoints.accounts.securityQuestions + "/" + cpf).pipe(map((data: any) => {
			return data.Retorno.Perguntas.map(item => {
				const question = new Question();

				question.code = item.CodigoPergunta;
				question.description = item.DescricaoPergunta;
				question.type = 1;
				question.size = 40;

				return question;

			});

		}));
	}

	sendAnswer(cpf, question, answer) {

		const answerData = {
			CpfCnpj: cpf,
			Respostas: [{
				CodigoPergunta: question.code,
				DescricaoPergunta: question.description,
				RespostaPergunta: answer
			}]
		};

		return this.http.post(endpoints.accounts.securityQuestions + '/validar', answerData);
	}

	getSmsCode(cpf) {

		return this.http.get(endpoints.accounts.users + cpf + endpoints.accounts.sms).pipe(map((data: any) => {

			const sms = new Sms();
			sms.uniqueNumer = data.Retorno.NroUnicoMsg;
			sms.type = data.Retorno.TpCodValidacao;
			sms.size = data.Retorno.TamCodValidacao;
			sms.lastDigits = data.Retorno.UltimosDigitosCelular;
			sms.message = data.Mensagem;

			return sms;

		}));


	}

	sendSmsCode(cpf, code) {

		const smsData = {
			Documento: cpf,
			CodigoValidacao: code
		};

		return this.http.post(endpoints.accounts.enviarSms, smsData);

	}

}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/change-digital-signature.service.ts